<div class="layout" [class.layout--collapsed]="isCollapsed()">
  <aside class="layout__sidenav">
    <div class="layout__logo">
      <img src="chevron-logo.png" alt="Chevron">
    </div>

    <button
      type="button"
      class="layout__toggle"
      (click)="toggleMenu()"
      [attr.aria-label]="isCollapsed() ? 'Expand menu' : 'Collapse menu'">
      <i class="pi pi-bars"></i>
    </button>

    <nav class="layout__nav">
      @for (item of menuItems; track item.label) {
        <a
          class="layout__nav-item"
          [routerLink]="item.routerLink"
          routerLinkActive="layout__nav-item--active"
          [pTooltip]="isCollapsed() ? item.label : ''"
          tooltipPosition="right"
          (click)="isCollapsed.set(true)">
          @if (item.iconSrc) {
            <img class="layout__nav-icon layout__nav-icon--image" [src]="item.iconSrc" [alt]="item.label">
          } @else {
            <i [class]="item.icon + ' layout__nav-icon'"></i>
          }
          <span class="layout__nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>
  </aside>

  <main class="layout__content">
    <router-outlet></router-outlet>
  </main>

  @if (showChat()) {
    <app-agent-chat></app-agent-chat>
  }
</div>